import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/InfinityV1/app/client-layout.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/InfinityV1/node_modules/.pnpm/next@15.5.7_@babel+core@7.28.5_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/var/www/InfinityV1/app/globals.css");
